import { SideNav, SideNavContent } from "components";
import PageHeader from "components/UniversalComponents/PageHeader";
import { HeaderDasNew, MainBody, OverlayLoader } from "components/core";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useMemo, useState } from "react";
import http from "services/httpService";
import styled from "styled-components";
import { colors } from "theme";
import TextInline from "./TextInline";
import Level from "./level";
import ServicingManager from "./ServicingManager";

function ClaimSupport() {
  const company_name = localStorage.getItem("company_name");
  const [tpaName, setTpaName] = useState("");
  const [tpas, setTpas] = useState();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(async () => {
    try {
      setIsLoading(true);
      const { data } = await http.get("dashboard/get_support_details/", {
        params: { flow: "company" },
      });
      setTpaName(data.claims_details.tpa_name);
      setTpas(data);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, []);
  const cashlessClaims = useMemo(() => {
    if (!tpas || !tpas.claims_details || !tpas.claims_details.cashless_details)
      return [];
    const detail = Object.groupBy(
      tpas.claims_details.cashless_details,
      ({ cashless_level }) => cashless_level
    );
    return Object.values(detail);
  }, [tpas]);

  const escalationDetails = useMemo(() => {
    if (
      !tpas ||
      !tpas.claims_details ||
      !tpas.claims_details.escalation_details
    )
      return [];

    const detail = Object.groupBy(
      tpas.claims_details.escalation_details,
      ({ escalation_level }) => escalation_level
    );
    return Object.values(detail);
  }, [tpas]);

  const neoManagers = useMemo(() => {
    if (!tpas) return [];
    if (
      tpas.relationship_manager.length > 0 ||
      tpas.servicing_manager.length > 0
    ) {
      return [...tpas.servicing_manager, ...tpas.relationship_manager];
    }
  }, [tpas]);

  const RenderContacts = (header, cashlessClaim, data) => {
    return (
      <>
        <div style={{ marginTop: "5rem" }}>
          <PageHeader header={header} />
        </div>
        <Level data={data} cashlessClaim={cashlessClaim} />
      </>
    );
  };

  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={company_name} />
          <MainBody>
            <WidthLimiter>
              <PageHeader header={"Administrator"} />
              {tpaName && <TextInline name={tpaName} />}
              {cashlessClaims.length > 0 &&
                RenderContacts("Contact Details", "cashless", cashlessClaims)}
              {escalationDetails.length > 0 &&
                RenderContacts(
                  "Escalation Matrix",
                  "escalation",
                  escalationDetails
                )}
            </WidthLimiter>
          </MainBody>
          <PageGap />
          <MainBody>
            <WidthLimiter>
              <PageHeader
                header={"Contacts for Neo Risk Management and Insurance Broker"}
              />
              <ServicingManager data={neoManagers} />
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </>
  );
}

export default ClaimSupport;

const PageGap = styled.div`
  height: 10px;
  width: 100%;
  background-color: #dadada;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
`;
